import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MwcIconModule } from 'mwc/icon';
import { MwcPopoverModule } from 'mwc/popover';
import { ColorSketchModule } from "ngx-color/sketch";
import { FooterColComponent } from './footer-col.component';
import { FooterItemComponent } from './footer-item.component';
import { FooterComponent } from './footer.component';

@NgModule({
  declarations: [FooterComponent, FooterColComponent, FooterItemComponent],
  exports: [FooterComponent],
  imports: [
    CommonModule,
    MwcIconModule,
    MwcPopoverModule,
    ColorSketchModule
  ]
})
export class FooterModule { }
